export const CRUCIBLE_WORKSPACE_ID = '0ed56aea-54c9-4485-987f-ffb35872eb38';
export const NORTHHILLPARTNERS_WORKSPACE_ID = 'e20ddb62-e6af-466e-ad2d-400aabc07f42';
export const VANCY_WORKSPACE_ID = 'a61ed280-61fa-4e19-8e54-88bffcc24a75';
export const MAIL_ART_WORKSPACE_ID = '7048d215-c1f5-4074-a821-9143a82dc8f3';
export const AGILE_VENTURE_WORKSPACE_ID = '126d8d6e-d016-4f81-8233-c3a3f89415fcs';
export const BLOCKED_USERS = [
  'text@linkupoverseas.com',
  'daveb@racivil.com',
  'testenlace@eunicetrevino.com',
  'info@southernsilage.com',
  'dennymathew@eynews.consulting',
  'bsibley@issifl.com',
  'contact@creditfix800.com',
  'aluno.mirella.spina@cermac.com.br',
  'joeem@ejraith.com',
  'adreyer@pspilots.org',
  'mwheeler@wilsonboats.com',
  'bruce@tizzanaminitugs.com.au',
  'kbielas@doorts.com',
  'lnelson@heritageacademy.net',
  'wells.kathyann231@gmail.com',
  'amoi@gowithspectrum.com',
  'mmeador@philmeador.com',
  'sarahwilliams26@gmail.com',
];
